export function showSnackbarSafely(data) {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const globalWindow = typeof window !== 'undefined' ? window : null;
  const snackbar = globalWindow && globalWindow.snacks;

  if (snackbar && typeof snackbar.showSnackbar === 'function') {
    snackbar.showSnackbar(data);
    return true;
  }

  if (typeof console !== 'undefined' && console && typeof console.warn === 'function') {
    console.warn('snacks: helper unavailable', data.message || data);
  }

  return false;
}
